import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { clear } from '../../actions/search';

import useTrackPageView from '../../hooks/useTrackPageView';
import { getMarket } from '../../i18n';
import ArticlesSection from './ArticlesSection';
import LiveShopping from './Liveshopping';
import SellYourCar from './SellYourCar';
import Hero from './hero';
import SelectedCategories from './selected-categories';

const Startpage = () => {
  const dispatch = useDispatch();
  const market = getMarket();
  const actions = bindActionCreators(
    {
      clear,
    },
    dispatch,
  );
  const { t } = useTranslation('global');
  const trackPageViewEvent = useTrackPageView();

  useEffect(() => {
    actions.clear();
    document.title = `${t('brandName', { ns: 'global' })} – ${t('titleSlogan', { ns: 'global' })}`;
    trackPageViewEvent();
  }, []);

  return (
    <>
      <Hero />
      <div data-wx-page="" className="container m-b-double">
        <SelectedCategories />
        <SellYourCar />
        {false && market.marketCode === 'SE' && <LiveShopping />}
        <ArticlesSection />
      </div>
    </>
  );
};

export default Startpage;
